import styles from '../ApplicationMaintenance.module.scss';
import Modal from '@mui/material/Modal';
import Base from '../../Base/Base';
import { Button } from '@upmc/ims.component-library';
import { useState } from 'react';
const ReqNumModal = ({
	reqNum,
	setReqNum,
	open,
	setOpen,
	omitReadOnly = false,
}) => {
	const [inputValue, setInputValue] = useState(reqNum);
	return (
		<Modal
			open={open}
			onClose={() => {
				setOpen(false);
				setInputValue(reqNum);
			}}
		>
			<div className={styles.Modal}>
				<Base className={styles.APPLY_FONT} title='Related Requirement'>
					<p>
						<strong>Requirement Number</strong>
					</p>
					<p className={styles.sub_label}>
						Enter the requirement number of the related Azure Dev
						Ops requirement for which you will be making changes for
					</p>
					<input
						type='number'
						onChange={e => setInputValue(e.target.value)}
						className={styles.margin_top_1}
						value={inputValue}
					></input>
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								setReqNum(inputValue);
								setOpen(false);
							}}
							sx={{ m: '1rem' }}
							id='requirementNumber_Save'
						>
							Set Requirement Number
						</Button>
						{omitReadOnly !== true ? (
							<Button
								onClick={e => {
									setReqNum(null);
									setOpen(false);
								}}
								variant='outlined'
								id='readOnly_Button'
								sx={{ m: '1rem' }}
							>
								Continue as Read Only
							</Button>
						) : null}
					</div>
				</Base>
			</div>
		</Modal>
	);
};

export default ReqNumModal;
